<style lang="scss" scoped>
  @import "./confirm.scss";
</style>
<script>
import CartItems from '../cart-items/cart-items.vue'
import TransactionBillingInfo from '../transaction-billing-info/transaction-billing-info'
import TransactionPaymentInfo from '../transaction-payment-info/transaction-payment-info'
import TransactionShippingInfo from '../transaction-shipping-info/transaction-shipping-info'
import TokenPaymentInfo from '../token-payment-info/token-payment-info'

import consumer from '../../utils/consumer'
import { mapGetters } from 'vuex'

export default {
  name: 'Confirm',
  components: {
    CartItems,
    TransactionBillingInfo,
    TransactionPaymentInfo,
    TransactionShippingInfo,
    TokenPaymentInfo
  },

  data () {
    return this.confirmDetails()
  },

  computed: {
    ...mapGetters(['totalItems', 'srcTransactionId'])
  },

  created () {
    if (!this.cartDetails || Object.keys(this.$store.getters.products).length === 0) {
      this.$router.push('/cart').catch(err => { console.error(err) })
    }
    this.$store.dispatch('decrement')
  },

  methods: {

    goToHomePage () {
      this.$router.push('/').catch(err => {
        console.error(err)
      })
    },

    confirmDetails () {
      const cartDetails = JSON.parse(localStorage.getItem('cartDetails'))
      this.$store.dispatch('setData')
      const decryptedData = consumer.getDecryptedData() || {}
      const mockPayloadResponse = consumer.getPayloadResponse(decryptedData) || {}
      this.$store.dispatch('updateEnableConfirmation', false)
      return {
        payloadResponse: mockPayloadResponse,
        orderId: this.srcTransactionId,
        cartDetails: cartDetails,
        billingAddress: (mockPayloadResponse.maskedCard || {}).billingAddress || {},
        shippingAddress: (mockPayloadResponse.maskedCard || {}).shippingAddress || {}
      }
    }
  }

}
</script>

<template>
  <div
    class="container"
    data-test="confirm"
  >
    <div
      class="text-center"
    >
      <h3 class="pt-4 font-weight-bold">
        {{ $t ('label.orderConfirmation') }}
      </h3>
      <h6 class="mt-4">
        {{ $t ('label.order') }} {{ srcTransactionId }}
      </h6>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6 mt-5">
        <h4 class="font-weight-bold pl-md-3">
          {{ $t ('header.orderSummary') }}
        </h4>
        <div
          id="confirm-cart-items"
          class="pl-md-3"
          data-test="confirm-cart-items"
        >
          <cart-items :cart-details="cartDetails" />
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 mt-5 pl-md-5">
        <div
          v-if="!payloadResponse.token"
          id="confirm-transaction-payment-info"
          data-test="confirm-payment-info"
        >
          <transaction-payment-info :masked-card="payloadResponse.maskedCard || {}" />
        </div>
        <div
          v-if="payloadResponse.token"
          id="confirm-token-payment-info"
          data-test="confirm-payment-info"
        >
          <token-payment-info :masked-token="payloadResponse.maskedToken || {}" />
        </div>
        <hr>
        <div
          id="confirm-billing-info"
          data-test="confirm-billing-info"
        >
          <transaction-billing-info
            :masked-billing-address="billingAddress"
            :masked-consumer="payloadResponse.maskedConsumer || {}"
          />
        </div>
        <hr>
        <div
          id="confirm-shipping-info"
          data-test="confirm-shipping-info"
        >
          <transaction-shipping-info
            :masked-consumer="payloadResponse.maskedConsumer || {}"
            :payload-response="payloadResponse"
            :masked-shipping-address="shippingAddress"
          />
          <button
            id="continue-shopping-btn"
            class="btn btn-primary btn-lg pull-right my-5 mr-md-4"
            @click="goToHomePage()"
          >
            {{ $t ('label.continueShopping') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
